import React from "react";
import { Tooltip } from "@mui/material";
import ReactSwitch from "react-switch";
import { CheckboxIcon, HeartIcon, PencilIcon } from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import { useSnapshot } from "valtio";
import { toast } from "react-toastify";

import { setDefaultSetting, setIsLoading, store } from "../store";
import { store as globalStore } from "@components/VerticalLayout/store";

import { updateSaleModesAndPaymentMethods } from "@helpers/general";
import { editSale } from "./helper";
import { useFetchGlobal } from "../../../../../api/hooks";

export function CustomIcons({
    e,
    setRowData,
    setIsAddSaleClicked,
    setDataIsUpdated,
    dataIsUpdated,
    setIsAddSaleSupportClicked,
}: any): JSX.Element {
    const { fetchGlobal } = useFetchGlobal();
    const { t } = useTranslation();
    const { franchiseID } = useSnapshot(globalStore);
    const { defaultSetting, isLoading } = useSnapshot(store);

    const handleHeartClick = () => {
        const updatedRows = defaultSetting.saleSupport?.data?.map(
            (row: any) => {
                if (row.Id === e.selectedRow.Id) {
                    return { ...row, isFavorite: true };
                }
                return { ...row, isFavorite: false };
            }
        );
        editSale(
            franchiseID,
            updatedRows,
            setIsAddSaleSupportClicked,
            setDataIsUpdated,
            dataIsUpdated,
            fetchGlobal,
            defaultSetting.saleMode.data,
            defaultSetting.paymentMethod.data
        );
        toast.success(`${t("Favorite state has been enabled successfully")}`, {
            position: toast.POSITION.TOP_CENTER,
            theme: "colored",
            icon: <CheckboxIcon height={25} width={25} fill="white" />,
        });
    };

    const handlePencilClick = () => {
        setRowData(e.selectedRow);
        setIsAddSaleClicked(true);
    };

    const handleSwitchChange = async (isChecked: boolean) => {
        setIsLoading(true);
        const updatedSaleSupports = defaultSetting.saleSupport?.data?.map(
            (row: any) => {
                if (row.Id === e.selectedRow.Id) {
                    return { ...row, status: isChecked };
                }
                return row;
            }
        );
        if (!isChecked) {
            const {
                updatedSaleModes,
                updatedPaymentMethod,
            } = updateSaleModesAndPaymentMethods(
                e.selectedRow.status,
                updatedSaleSupports,
                defaultSetting
            );
            setDefaultSetting({
                ...defaultSetting,
                saleSupport: { data: [...updatedSaleSupports] },
                saleMode: { data: [...updatedSaleModes] },
                paymentMethod: { data: [...updatedPaymentMethod] },
            });
            editSale(
                franchiseID,
                updatedSaleSupports,
                setIsAddSaleSupportClicked,
                setDataIsUpdated,
                dataIsUpdated,
                fetchGlobal,
                updatedSaleModes,
                updatedPaymentMethod
            );
        } else {
            editSale(
                franchiseID,
                updatedSaleSupports,
                setIsAddSaleSupportClicked,
                setDataIsUpdated,
                dataIsUpdated,
                fetchGlobal
            );
            setDefaultSetting({
                ...defaultSetting,
                saleSupport: { data: [...updatedSaleSupports] },
            });
        }

        toast.success(
            `${t(
                isChecked
                    ? "Sale support has been successfully activated"
                    : "Sale support has been successfully deactivated"
            )}`,
            {
                position: toast.POSITION.TOP_CENTER,
                theme: "colored",
                icon: <CheckboxIcon height={25} width={25} fill="white" />,
            }
        );
    };

    return (
        <div className="d-flex justify-content-around">
            <Tooltip
                title={
                    e.selectedRow[t("Nom d'affichage")] === ""
                        ? ""
                        : e.selectedRow.status === false
                        ? t("Activate")
                        : t("Unactivate")
                }
                arrow
            >
                <div>
                    <ReactSwitch
                        disabled={
                            e.selectedRow[t("Nom d'affichage")] === "" ||
                            isLoading === true
                        }
                        uncheckedIcon={false}
                        checkedIcon={false}
                        handleDiameter={26}
                        offColor="#f7b4b8"
                        offHandleColor="#E30613"
                        onColor="#c2eddd"
                        onHandleColor="#34C38F"
                        width={50}
                        height={20}
                        checked={e.selectedRow.status}
                        onChange={() =>
                            handleSwitchChange(!e.selectedRow.status)
                        }
                    />
                </div>
            </Tooltip>
            <div className="ml-3">
                <Tooltip
                    title={
                        e.selectedRow.isFavorite === true
                            ? ""
                            : t("Enable favorite state")
                    }
                    arrow
                >
                    <div>
                        <HeartIcon
                            onClick={handleHeartClick}
                            height={25}
                            width={25}
                            name="heart"
                            fill={e.selectedRow.isFavorite ? "red" : "black"}
                            style={{ cursor: "pointer" }}
                        />
                    </div>
                </Tooltip>
            </div>
            <div className="ml-3">
                <Tooltip title={t("To modify")} arrow>
                    <div>
                        <PencilIcon
                            onClick={handlePencilClick}
                            height={25}
                            width={25}
                            style={{ cursor: "pointer" }}
                        />
                    </div>
                </Tooltip>
            </div>
        </div>
    );
}
